const chunkMapping = {
	"383": [
		383
	],
	"2295": [
		1181,
		1754,
		2326,
		5382
	],
	"4173": [
		4173
	],
	"4915": [
		4915
	],
	"5034": [
		5034
	],
	"5204": [
		5204
	],
	"6047": [
		6047
	],
	"6276": [
		6276
	],
	"6303": [
		6303
	],
	"7032": [
		7032
	],
	"7745": [
		7745
	],
	"7936": [
		7936
	],
	"8536": [
		8536
	],
	"8789": [
		125,
		9590
	],
	"9169": [
		9169
	],
	"9245": [
		9245
	],
	"9844": [
		9844
	]
};
const idToExternalAndNameMapping = {
	"125": [
		"default",
		"./Aside",
		1217
	],
	"383": [
		"default",
		"./PIPView",
		2647
	],
	"1181": [
		"default",
		"./CustomerProvider",
		3537
	],
	"1754": [
		"default",
		"./ServiceProvider",
		5861
	],
	"2326": [
		"default",
		"./CartStoreProvider",
		5861
	],
	"4173": [
		"default",
		"./SearchView",
		4977
	],
	"4915": [
		"default",
		"./CopilotFrame",
		5861
	],
	"5034": [
		"default",
		"./languageService",
		7013
	],
	"5204": [
		"default",
		"./Admin",
		1199
	],
	"5382": [
		"default",
		"./SupportGuideOverlay",
		161
	],
	"6047": [
		"default",
		"./CustomerOrders",
		5861
	],
	"6276": [
		"default",
		"./Catalog",
		7843
	],
	"6303": [
		"default",
		"./CartToast",
		5861
	],
	"7032": [
		"default",
		"./Header",
		1217
	],
	"7745": [
		"default",
		"./Browse",
		7843
	],
	"7936": [
		"default",
		"./KitchenDetail",
		2647
	],
	"8536": [
		"default",
		"./colorHelper",
		7013
	],
	"9169": [
		"default",
		"./CartView",
		5861
	],
	"9245": [
		"default",
		"./CombinationView",
		2647
	],
	"9590": [
		"default",
		"./layoutSizeHelper",
		7013
	],
	"9844": [
		"default",
		"./ScrollToTop",
		7013
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			let getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			const data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			const onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			const handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					const promise = fn(arg1, arg2);
					if(promise?.then) {
						const p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			const onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			const onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			const onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}